/* eslint-disable @typescript-eslint/default-param-last */
import { HIDE_MODAL, SHOW_MODAL } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IModalAction } from '../types/modal.types';

const modalReducer = (state = initialState.modal, action: IModalAction) => {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        confirmModal: action.payload.confirmModal,
      };
    case HIDE_MODAL:
      return {
        ...state,
        confirmModal: null,
      };
    default:
      return state;
  }
};

export default modalReducer;
